import { CSSProperties } from 'react'
import { Dropdown } from 'react-bootstrap'

export interface DropDownType {
  name: string
  value?: string | number
  options: OptionsType[] | string[] | number[]
  handleChange: (value) => void
  type?: string
  placeholder?: string
  small?: boolean
  style?: CSSProperties
}

export interface OptionsType {
  id: number | string
  name: string
  options?: {
    start: string
    end: string
  }
  periodForSale?: { start?: Date; end?: Date }
}

const DropDown = (props: DropDownType): JSX.Element => {
  function handleChangeValue(value): void {
    props.handleChange(value)
  }
  return (
    <div
      className={'dropdown-system' + (props.small ? '-small' : '')}
      style={props.style}
    >
      <Dropdown>
        <Dropdown.Toggle
          className={'dropdown-custom' + (props.type ? props.type : '')}
          id={props.name}
        >
          {!props.value ? (
            <div className="dropdown-placeholder">{props.placeholder}</div>
          ) : (
            ''
          )}

          {props.value ? (
            <div className="show-data">
              {props.options.map((item) => {
                if (item.id && item.id === props.value) return item.name
                else if (item === props.value) return item
                return ''
              })}
            </div>
          ) : (
            ''
          )}
        </Dropdown.Toggle>
        <Dropdown.Menu align="start" className="dropdown-menu-custom">
          {props.options.map((item, index) => {
            return (
              <Dropdown.Item
                onClick={() => handleChangeValue(item?.id ? item?.id : item)}
                key={props.name + index}
                className={
                  props.value &&
                  (item === props.value || item?.id === props.value)
                    ? 'selected'
                    : ''
                }
              >
                {item?.id ? item?.name : item}
              </Dropdown.Item>
            )
          })}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}

export default DropDown
